module.exports = __webpack_public_path__ + "static/media/starship.bdec9d5b.jpg";